import React, { useEffect, useState } from "react";
import { VscDebugRestart } from "react-icons/vsc";
import { getAllProjects, getProjectById } from "../../service/MainService";
import { useNavigate } from "react-router-dom";
import noimg from "../../assets/images/noimg.webp";

const TopProjects = () => {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsData = await getAllProjects(0, 8, {});
        if (projectsData && projectsData.Result) {
          setProjects(projectsData.Result);
        }
      } catch (err) {
        console.error("Failed to load top projects", err);
      }
    };
    fetchProjects();
  }, []);

  const navigateToProjectDetail = async (projectId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const projectDetails = await getProjectById(projectId, token);
      navigate(`/project/${projectId}`, {
        state: { projectDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  return (
    <>
      <div className="py-5 lg:py-10">
        <h1 className="mb-5 lg:mb-10 flex items-center gap-2 lg:gap-10 justify-center text-xl lg:text-3xl font-semibold">
          <VscDebugRestart /> The most recent
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-8">
          {projects.map((project, index) => (
            <React.Fragment key={index}>
              <div 
                className="relative cursor-pointer shadow-md"
                onClick={() => navigateToProjectDetail(project.ProjectId)}
              >
                <img
                  src={project.Image1 || (project.ImageUrls && project.ImageUrls.length > 0 ? project.ImageUrls[0] : noimg)}
                  alt={project.ProjectName || "Project"}
                  className="w-full h-40 sm:h-60 object-cover"
                />
                <div className="absolute inset-0 flex flex-col gap-2 items-center justify-end pb-4 bg-black bg-opacity-40 text-white transition-opacity duration-300">
                  <p className="text-sm sm:text-lg font-bold text-center">
                    {project.ProjectName}
                  </p>
                  <p className="text-xs sm:text-sm">{project?.Country?.countryName || "NA"}</p>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default TopProjects;

